import { ROLE_DESCRIPTIONS, UserRole } from "@/shared/constants/user-roles"

export const volunteerPositionsOptions = ROLE_DESCRIPTIONS
    .filter((role) => 
        role.name !== UserRole.ADMIN && 
        role.name !== UserRole.HOMEOWNER && 
        role.name !== UserRole.PARTNER
    )
    .map((role) => ({
        label: role.name,
        value: role.id.toString(),
    }))

export const statusFilterOptions = [
    {
        label: 'Active',
        value: 'active',
    },
    {
        label: 'Inactive',
        value: 'inactive',
    },
] as const

/** Options for Status filter in Filter popup (includes All) */
export const statusFilterWithAllOptions = [
    { label: 'All', value: 'all' },
    { label: 'Active', value: 'active' },
    { label: 'Inactive', value: 'inactive' },
]

export const roleFilterOptions = ROLE_DESCRIPTIONS
    .filter((role) => role.name !== UserRole.HOMEOWNER)
    .map((role) => ({
        label: role.name,
        value: role.name,
    }))

export const locationsFilterOptions = [
    {
        label: 'Location 1',
        value: 'location-1',
    },
    {
        label: 'Location 2',
        value: 'location-2',
    },
    {
        label: 'Location 3',
        value: 'location-3',
    },
] as const

/** Experience & Skills database titles for filtering (e.g. group volunteers by skill). */
export const experienceSkillsFilterOptions = [
    { label: 'General construction', value: 'experienceConstruction' },
    { label: 'Manual labor', value: 'experienceManualLabor' },
    { label: 'Leading at work site', value: 'experienceLeadingTeams' },
    { label: 'Drywall finishing', value: 'experienceDrywallFinishing' },
    { label: 'Rough carpentry', value: 'experienceRoughCarpentry' },
    { label: 'Finish carpentry', value: 'experienceFinishCarpentry' },
    { label: 'Flooring', value: 'experienceFlooring' },
    { label: 'Woodworking', value: 'experienceWoodWorking' },
    { label: 'Electrical', value: 'experienceElectrical' },
    { label: 'Plumbing', value: 'experiencePlumbing' },
    { label: 'HVAC', value: 'experienceHvac' },
    { label: 'Arborist / tree work', value: 'experienceArborist' },
    { label: 'Roofing', value: 'experienceRoofing' },
    { label: 'Heavy equipment', value: 'experienceHeavyEquipment' },
    { label: 'Data management', value: 'experienceDataManagement' },
    { label: 'Storytelling / social media', value: 'experienceStorytelling' },
    { label: 'Alternative ministries', value: 'experienceAltMinistries' },
    { label: 'Meal preparation', value: 'mealPreparationAbility' },
] as const